import { api, apiStatic } from 'AurionCR/components';
import axios, { InternalAxiosRequestConfig } from 'axios';
import React, { ReactNode, useEffect } from 'react';
import { prepareDateToSave } from './index';
import { API_AUTH } from 'services/account/models';

const instances = [apiStatic, api, axios];

const decodeUrlsInObject = (obj: any): any => {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(decodeUrlsInObject);
  }

  const result: any = {};
  for (const [key, value] of Object.entries(obj)) {
    if (typeof value === 'string' && value.includes('%')) {
      try {
        result[key] = decodeURIComponent(value);
      } catch {
        result[key] = value;
      }
    } else if (typeof value === 'object' && value !== null) {
      result[key] = decodeUrlsInObject(value);
    } else {
      result[key] = value;
    }
  }
  return result;
};

// const handleResponse = (response: AxiosResponse) => {
//   if (response.data && typeof response.data === 'object') {
//     response.data = decodeUrlsInObject(response.data);
//   }
//   return response;
// };

const prepareConfig = (conf: InternalAxiosRequestConfig) => {
  // Skip processing if the API path matches API_AUTH.API
  if (conf.url && conf.url.includes(API_AUTH.API)) {
    return conf;
  }
  
  if (
    (conf.method === 'post' || conf.method === 'put') &&
    conf.data &&
    typeof conf.data === 'object' &&
    Object.getPrototypeOf(conf.data) === Object.prototype
  ) {
    conf.data = prepareDateToSave(conf.data);
  }
  return conf;
};

interface Props {
  children: ReactNode;
}

export const AxiosInterceptorPost: React.FC<Props> = ({ children }) => {
  useEffect(() => {
    instances.map((instance) => {
      instance.interceptors.request.use(prepareConfig);
      // instance.interceptors.response.use(handleResponse);
    });
  }, []);

  return <>{children}</>;
};
